import dialog from './dialog.vue'
dialog.install = function (Vue) {
  Vue.component(dialog.name, dialog);
};
export default dialog



// WEBPACK FOOTER //
// ./src/ni-ui/dialog/index.js